import React, { useEffect, useState } from "react";
import { Table, Pagination, Popconfirm } from "antd";
import { useDebounce } from "use-lodash-debounce";
import { reOrgActions } from "../ReOrgs/actions";
import { userActions } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import "antd/lib/popconfirm/style/css.js";
import i18nGlobal from "../../../localization";
import i18n from "../localization";
import i18nLocal from "./localization";
import ReOrgCreateUpdateForm from "./modify";
import RegisterExternal from "./registerExternal";
import CustomButton from "../../../components/ButtonCustom";
import { CustomInput } from "../../../components/CustomInput";
import Notifications from "../../../helpers/Notifications";
import Search from "../../../../public/search.svg";
import CRUDIcons from "../../../components/CRUDIcons/index"

const ReOrgs = (props) => { //'Организации и индивидуальные предприниматели' 
  const { isModify = false, reOrg = undefined } = props;
  const pageSize = 10;
  const [table, setTable] = useState([]);
  const [page, setPage] = useState(1);
  const [allPaged, setAllPaged] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleRegister, setVisibleRegister] = useState(false);
  const [record, setRecord] = useState(null);
  const [recordOrg, setRecordOrg] = useState(null);
  const [value, setValue] = useState("");
  const searchValue = useDebounce(value, 500);
  const { orgUnitChanged } = useSelector((state) => state.managementReducer);
  const Orgs = useSelector((state) => state.reOrgReducer.currentItem);
  const { orgChanged, isSending } = useSelector((state) => state.reOrgReducer);
  const { registerByAdminSuccess } = useSelector((state) => state.userReducer);

  const dispatch = useDispatch();
  const isRu = useSelector((state) => state.globalReducer.isRu);

  const getOrgByName = (params) => {
    dispatch(reOrgActions.getOrgByName(params));
  };

  const update = (params) => {
    dispatch(reOrgActions.updateReOrg(params));
  };
  const create = (params) => {
    dispatch(reOrgActions.createReOrg(params));
  };
  const deleteOrg = (params) => {
    dispatch(reOrgActions.deleteReOrg(params));
  };

  useEffect(() => {
    return () => {
      dispatch(reOrgActions.isTypesStatusesClear());
      dispatch(userActions.clearRegisterByAdmin());
    };
  }, []);

  useEffect(() => {
    if (orgChanged) {
      Notifications.successNotice(orgChanged, "", 15);
      onPaginationChange(page);
    }
  }, [orgChanged]);

  useEffect(() => {
    if (orgUnitChanged) {
      onPaginationChange(page);
    }
  }, [orgUnitChanged]);

  useEffect(() => {
    if (registerByAdminSuccess) onPaginationChange(page);
  }, [registerByAdminSuccess]);

  useEffect(() => {
    if (Orgs?.items) {
      if (Orgs.items.length == 0 && page !== 1) onPaginationChange(page - 1);
      else {
        setTable(
          Orgs.items.map((value, index) => {
            return {
              change: isModify && value.id,
              dateCreate: new Date(value.dateCreate).toLocaleDateString(
                "ru-RU"
              ),
              dateUpdate: value.dateUpdate
                ? new Date(value.dateUpdate).toLocaleDateString("ru-RU")
                : "",
              delete: isModify && value.id,
              fullName: value.fullName,
              fullNameBel: value.fullNameBel,
              id: value.id,
              isWithExternalAdmin: value.isWithExternalAdmin,
              reOrgTypeName: value.reOrgType.name,
              reOrgTypeNameBel: value.reOrgType.nameBel,
              rowKey: index,
              reOrgStatusTypeName: value.reOrgStatusType.name,
              reOrgStatusTypeNameBel: value.reOrgStatusType.nameBel,
              unp: value.unp,
            };
          })
        );
      }
    }
  }, [Orgs]);

  useEffect(() => {
    setPage(1);
    const name = searchValue.trim().length > 2 ? searchValue.trim() : "";
    if (!name && !allPaged) {
      getOrgByName({
        name: name,
        page: 1,
        pageSize: pageSize,
        reOrgId: reOrg,
      });
      setAllPaged(true);
    }
    if (name) {
      getOrgByName({
        name: name,
        page: 1,
        pageSize: pageSize,
        reOrgId: reOrg,
      });
      setAllPaged(false);
    }
  }, [searchValue]);

  function onPaginationChange(value) {
    setPage(value);
    getOrgByName({
      name: searchValue.trim().length > 2 ? searchValue.trim() : "",
      page: value,
      pageSize: pageSize,
      reOrgId: reOrg,
    });
  }

  function showModal(id) {
    const item = Orgs?.items?.find((value) => {
      return value.id === id;
    });
    setRecord(item);
    setVisible(true);
  }

  const columns = [
    {
      dataIndex: "unp",
      inputType: "text",
      key: "unp",
      title: i18n.tableHeaderUNP[isRu],
      width: 100,
    },
    {
      dataIndex: "reOrgStatusTypeName",
      inputType: "text",
      key: "reOrgStatusTypeName",
      render: (text, record) =>
        isRu
          ? record.reOrgStatusTypeName
            ? record.reOrgStatusTypeName
            : record.reOrgStatusTypeNameBel
          : record.reOrgStatusTypeNameBel
          ? record.reOrgStatusTypeNameBel
          : record.reOrgStatusTypeName,
      title: i18n.tableHeaderStatus[isRu],
    },
    {
      dataIndex: "fullName",
      inputType: "text",
      key: "fullName",
      title: i18n.tableHeaderFullNameRu[isRu],
    },
    {
      dataIndex: "fullNameBel",
      inputType: "text",
      key: "fullNameBel",
      title: i18n.tableHeaderFullNameBel[isRu],
    },
    {
      dataIndex: "reOrgTypeName",
      inputType: "text",
      key: "reOrgTypeName",
      render: (text, record) =>
        isRu
          ? record.reOrgTypeName
            ? record.reOrgTypeName
            : record.reOrgTypeNameBel
          : record.reOrgTypeNameBel
          ? record.reOrgTypeNameBel
          : record.reOrgTypeName,
      title: i18n.tableHeaderType[isRu],
    },
    {
      dataIndex: "dateCreate",
      inputType: "text",
      key: "dateCreate",
      title: i18n.tableHeaderDateStart[isRu],
    },
    {
      dataIndex: "dateUpdate",
      inputType: "text",
      key: "dateUpdate",
      title: i18n.tableHeaderDateUpdate[isRu],
    },
  ];

  isModify
    ? columns.push(
        {
          dataIndex: "change",
          key: "update",
          className: "reOrgsIconsColumn", 
          render: (id, record) => {
            return(
              <div className="reOrgsIcons">
                <span title={i18n.buttonEdit[isRu]}>
                  {CRUDIcons.update(() => {
                      showModal(id);
                    })}
                </span>
                <span title={i18nLocal.registerOrg[isRu]}>
                  {!record.isWithExternalAdmin && CRUDIcons.registrate(() => {
                    setVisibleRegister(true);
                    setRecordOrg(record);
                  })}
                </span>
                <span title={i18n.buttonDelete[isRu]}>
                  {!reOrg && 
                  <Popconfirm
                    cancelText={i18nGlobal.no[isRu]}
                    okText={i18nGlobal.yes[isRu]}
                    title={i18n.messageChooiseDeleteItem[isRu]}
                    onCancel={() => {
                      return null;
                    }}
                    onConfirm={() => {
                      deleteOrg({ id: id });
                    }}
                  >
                    {CRUDIcons.delete() }
                  </Popconfirm>}
                </span>
              </div>
          )},
          width: 150
        })
    : null;

  return (
    <>
      {window.scrollTo(0, 0)}
      {isModify && (
        <>
          <ReOrgCreateUpdateForm
            create={create}
            record={record}
            reOrg={reOrg}
            setRecord={setRecord}
            setVisible={setVisible}
            update={update}
            visible={visible}
          />
          <RegisterExternal
            reOrg={recordOrg}
            setReOrg={setRecordOrg}
            setVisible={setVisibleRegister}
            visible={visibleRegister}
          />
        </>
      )}
      <div style={{ width: reOrg ? "100%" : null }}>
        {!reOrg ? (
          <div className="header-admin-nsi">
            <CustomInput
              maxLength={64}
              placeholder={i18n.reOrgSearchPlaceholder[isRu]}
              onChange={(e) => setValue(e.target.value)}
            />
            {isModify && (
              <CustomButton
                className="add-nsi"
                loading={isSending}
                type="orange"
                onClick={() => showModal()}
              >
                <div>
                  {CRUDIcons.create()}
                  <span>{i18n.buttonAdd[isRu]}</span>
                </div>
              </CustomButton>
            )}
          </div>
        ) : (
          <div>
            <div className="addButtonUnit">
              <CustomButton
                loading={isSending}
                type="orange"
                onClick={() => showModal()}
              >
                {CRUDIcons.create()}
                <span>{i18n.buttonAdd[isRu]}</span>
              </CustomButton>
            </div>
            <CustomInput
              allowClear
              maxLength={64}
              placeholder={i18n.reOrgSearchPlaceholder[isRu]}
              prefix={<img src={Search} />}
              onChange={(e) => setValue(e.target.value)}
            />
          </div>
        )}
        <>
          <Table
            columns={columns}
            dataSource={table}
            loading={{ spinning: isSending, tip: i18nLocal.tipLoading[isRu] }}
            pagination={false}
            scroll={{ x: 1200 }}
          />
          {(Orgs?.count ?? 0) > pageSize && (
            <Pagination
              current={page}
              pageSize={pageSize}
              showSizeChanger={false}
              total={Orgs.count}
              onChange={onPaginationChange}
            />
          )}
        </>
      </div>
    </>
  );
};

export default ReOrgs;
